import React from 'react';
import DOMPurify from 'dompurify';
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import { AddToCart } from 'helpers/cart/AddToCart';

const ChallengesItemWidget = (props) => {
  const { t } = useTranslation();
  return (
    <div>
            <div>
                {
        props.items.map((item, index) => {

          const options = JSON.parse(JSON.parse(item.options));

          return (
            <div key={index}>
                                <div key={index}>
                                    <div>
                                        <LocalizedLink to={'challenge/' + item.id}>
                                            <span>{item.name}</span>
                                        </LocalizedLink>
                                    </div>
                                    <div>
                                        <div>
                                            <div>
                                                <span>{item.participants_total}/{options && options.participants_number ? options.participants_number : '-'}</span>
                                                <span>{t('challenge.start_at')}: <i>{item.start_at}</i></span>
                                            </div>
                                            <div>
                                                <span>{t('labels.participants')}</span>
                                                <span>{t('challenge.stop_at')}: <i>{item.stop_at}</i></span>
                                            </div>
                                        </div>
                                        <div>
                                            <LocalizedLink to={'challenge/' + item.id}>
                                                <img src={item['img']} alt={t("Name of challenge")} />
                                                <span><i></i></span>
                                            </LocalizedLink>
                                        </div>
                                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description) }}></p>
                                        <div>
                                            <span>{t('labels.high_reward')}: {options?.reward1ST ? options.reward1ST : '-'} </span>
                                            <div>
                                                <AddToCart item={item} index={index}></AddToCart>
                                                <span>{item && item.price ? item.price : '-'} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>);

        })
        }
            </div>
        </div>);

};

export default ChallengesItemWidget;